import { FC } from 'react';
import { Tabs, Tab } from '../../common/components/Tabs/Tabs';
import { AutopsyProtocolForm } from './AutopsyProtocol/AutopsyProtocolForm';
import { ProtocolProvider, useProtocol } from './context';
import { ProtocolContainer, StyledPageTitle, ProtocolTitleInfo, TabsCard } from './styles';
import { DeceasedForm } from '../Deceased/DeceasedForm';
import { RequestsPage } from './Requests/RequestsPage';
import { LabMaterialsForm } from './LabMaterials/LabMaterialsForm';
import { LabResultsPage } from './LabResults';
import { LabRequestsList } from './LabRequestsList';

const ProtocolContent: FC = (): JSX.Element => {
  const { protocol } = useProtocol();

  return (
    <ProtocolContainer>
      <StyledPageTitle>
        <ProtocolTitleInfo>
          <div>Protokol | {protocol?.protocol_number}</div>
          <div>{protocol?.deceased_display}</div>
        </ProtocolTitleInfo>
      </StyledPageTitle>

      <TabsCard>
        <Tabs>
          <Tab title="Pacient" pageSlug="patient">
            <DeceasedForm deceasedId={protocol?.deceased ?? undefined} />
          </Tab>
          <Tab title="Pitevní protokol" pageSlug="protocol">
            <AutopsyProtocolForm />
          </Tab>
          <Tab title="Žádanka/komplement" pageSlug="requests">
            <RequestsPage />
          </Tab>
          <Tab title="Laboratorní výsledky" pageSlug="results">
            <LabResultsPage />
          </Tab>
          <Tab title="Předávací protokol" pageSlug="handover-protocol">
            <LabMaterialsForm protocolId={protocol?.id ?? undefined} />
          </Tab>
          <Tab title="Seznam žádanek" pageSlug="lab-requests-list">
            <LabRequestsList />
          </Tab>
        </Tabs>
      </TabsCard>
    </ProtocolContainer>
  );
};

export const Protocol: FC = (): JSX.Element => {
  return (
    <ProtocolProvider>
      <ProtocolContent />
    </ProtocolProvider>
  );
};
